import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const NoResult = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width="121"
      height="120"
      viewBox="0 0 121 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="Frame" clipPath="url(#clip0_2982_23985)">
        <g id="Group">
          <path
            id="Vector"
            d="M93.3182 104.062C111.442 85.9379 111.442 56.5527 93.3171 38.4288C75.1925 20.3049 45.8073 20.3054 27.6834 38.4299C9.55952 56.5545 9.56004 85.9397 27.6846 104.064C45.8091 122.187 75.1943 122.187 93.3182 104.062Z"
            fill="white"
            stroke="#686869"
            strokeWidth="3"
            strokeMiterlimit="22.9256"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_2"
            d="M78.4012 89.1476L53.042 78.7039L42.5983 53.3447L67.9574 63.7882L78.4012 89.1476ZM60.4998 107.109C80.3066 107.109 96.363 91.0529 96.363 71.2461C96.363 51.4393 80.3064 35.3829 60.4998 35.3829C40.693 35.3829 24.6367 51.4395 24.6367 71.2461C24.6365 91.0531 40.693 107.109 60.4998 107.109Z"
            fill="#CCE7FE"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <g id="Vector_3">
            <path
              d="M60.5001 45.9298V49.3109V45.9298ZM60.5001 93.1814V96.5625V93.1814ZM35.1836 71.2463H38.5647H35.1836ZM82.4352 71.2463H85.8163H82.4352ZM42.5988 89.1476L45.0046 86.7417L42.5988 89.1476ZM75.9955 55.7508L78.4014 53.3449L75.9955 55.7508ZM54.8856 17.6184C51.4682 16.1489 49.3673 13.4543 49.3673 10.5403C49.3673 6.01359 54.3515 2.34375 60.5001 2.34375C66.6487 2.34375 71.6329 6.01359 71.6329 10.5403C71.6329 13.477 69.4989 16.1895 66.0391 17.6505M67.9579 63.7884L78.4014 89.1476L53.0423 78.7041L42.5988 53.3449L67.9579 63.7884ZM53.871 77.8753L67.1291 64.6172L53.871 77.8753Z"
              fill="white"
              fillRule="evenodd"
              clipRule="evenodd"
            />
            <path
              d="M60.5001 45.9298V49.3109M60.5001 93.1814V96.5625M35.1836 71.2463H38.5647M82.4352 71.2463H85.8163M42.5988 89.1476L45.0046 86.7417M75.9955 55.7508L78.4014 53.3449M54.8856 17.6184C51.4682 16.1489 49.3673 13.4543 49.3673 10.5403C49.3673 6.01359 54.3515 2.34375 60.5001 2.34375C66.6487 2.34375 71.6329 6.01359 71.6329 10.5403C71.6329 13.477 69.4989 16.1895 66.0391 17.6505M53.871 77.8753L67.1291 64.6172M67.9579 63.7884L78.4014 89.1476L53.0423 78.7041L42.5988 53.3449L67.9579 63.7884Z"
              stroke="#686869"
              strokeWidth="3"
              strokeMiterlimit="22.9256"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g id="Vector_4">
            <path
              d="M54.9336 23.9977V19.043C54.9336 15.9813 57.4384 13.4766 60.5 13.4766C63.5616 13.4766 66.0664 15.9813 66.0664 19.043V23.9979"
              fill="white"
              fillRule="evenodd"
              clipRule="evenodd"
            />
            <path
              d="M54.9336 23.9977V19.043C54.9336 15.9813 57.4384 13.4766 60.5 13.4766C63.5616 13.4766 66.0664 15.9813 66.0664 19.043V23.9979"
              stroke="#686869"
              strokeWidth="3"
              strokeMiterlimit="22.9256"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2982_23985">
          <rect width="120" height="120" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

NoResult.displayName = 'NoResult';
